import React, { useEffect, useState } from "react";
import { Chart, registerInteraction } from "@antv/g2";
import { Empty } from "antd";
import Spin from "@/components/Spin";
import { DatabaseTwoTone } from "@ant-design/icons";

registerInteraction("element-link", {
  start: [
    {
      trigger: "interval:mouseenter",
      action: "element-link-by-color:link",
    },
  ],
  end: [
    {
      trigger: "interval:mouseleave",
      action: "element-link-by-color:unlink",
    },
  ],
});

const PieChart = ({ id, data, height = 400, width = 200 }) => {
  const [chartInstance, setChartInstance] = useState(null);

  const initChart = (cData) => {
    if (chartInstance) {
      chartInstance.changeData(cData);
      return;
    }
    const chart_b = new Chart({
      container: id,
      autoFit: true,
      height,
      width,
      // padding: [20, 20, 95, 80],
      // appendPadding: [20, 20, 95, 80]
    });

    chart_b.data(cData);

    // chart_b.scale("menu", {
    //     nice: true,
    //     range: [0.02, 0.98],
    // });

    chart_b.tooltip({
      showMarkers: false,
    });

    chart_b.axis("menu", {
      tickLine: null,
      label: {
        autoRotate: false,
        autoHide: false, // 取消自动隐藏label
        formatter(text) {
          // 字符太长添加省略号
          return window.innerWidth <= 1366 && text.length > 4
            ? `${text.slice(0, 4)}...`
            : text;
        },
      },
    });

    chart_b
      .interval()
      .position("menu*value")
      .color("type")
      .adjust([
        {
          type: "dodge",
          marginRatio: 0,
        },
      ]);

    chart_b.interaction("element-highlight-by-color");
    chart_b.interaction("element-link");

    chart_b.render();
    setChartInstance(chart_b);
  };

  useEffect(() => {
    if (data.length) {
      initChart(data);
    }
  }, [data]);

  return data.length ? (
    <section id={id}></section>
  ) : (
    <Empty style={{ height: 400, position: "relative" }}>
      <Spin size={2} style={{ backgroundColor: "#fff" }} />
    </Empty>
  );
};

export default PieChart;
